<template>
    <svg :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <circle cx="6.7" cy="9.2" r="4.9"/>
        <path d="M18.4,11.2h28.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9h-28.2c-1.1,0-1.9.9-1.9,1.9s.9,1.9,1.9,1.9Z"/>
        <circle cx="6.7" cy="24.8" r="4.9"/>
        <path d="M46.5,22.8h-28.2c-1.1,0-1.9.9-1.9,1.9s.9,1.9,1.9,1.9h28.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9Z"/>
        <circle cx="6.7" cy="40.3" r="4.9"/>
        <path d="M46.5,38.4h-28.2c-1.1,0-1.9.9-1.9,1.9s.9,1.9,1.9,1.9h28.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9Z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>